import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { HasUnsavedChanges } from './has-unsaved-changes.interface';
import { UnsavedChangesService } from './unsaved-changes.service';

/**
 * Blocks in-app navigation away from a screen with unsaved edits until the user
 * confirms. Attach with `canDeactivate: [unsavedChangesGuard]`; the routed
 * component must implement {@link HasUnsavedChanges}.
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges | null> = component => {
  if (!component?.hasUnsavedChanges()) {
    return true;
  }

  return inject(UnsavedChangesService).confirmDiscard$();
};
